<div class="chat-page-header">
  <!-- users profile -->
  <div class="chat-page-header__content">
    <div class="profiles-image">
      <img
        class="profiles-image__img"
        ngSrc="assets/images/mock-image/profile-3.png"
        alt="profile"
        width="40"
        height="40" />
      <img
        class="profiles-image__img"
        ngSrc="assets/images/mock-image/person.png"
        alt="profile"
        width="40"
        height="40" />
    </div>
    <!-- header content -->
    <div class="profiles-content">
      <h3 class="profiles-content__title">
        {{ 'global.support_team' | translate }}
      </h3>
      <p class="profiles-content__subtitle">
        {{ 'global.we_answer_you' | translate }}
      </p>
    </div>
  </div>
  <!-- close btn -->
  <button class="chat-page-header__close-btn" (click)="toggleChatBox()">
    <i class="iconsax close-icon" icon-name="x"></i>
  </button>
</div>
